import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Immutable from 'immutable';
import _ from 'underscore';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import FormController from 'lib/form/controller';
import BookingActionCreator from 'action_creators/booking';
import ConversationActionCreator from 'action_creators/conversation';
import ModalActionCreator from 'action_creators/modal';
import GlobalError from 'views/plugins/global_error';
import TextArea from 'views/ui/form_elements/textarea';
import Dimmer from 'views/shared/ui/dimmer';
import './index.scss';

const AcceptBooking = createReactClass({
  displayName: 'AcceptBooking',
  mixins: [PureRenderMixin, StoreInterestMixin, FormController],

  propTypes: {
    booking_id: PropTypes.number,
    tour_name: PropTypes.string,
    date: PropTypes.string,
    accepted: PropTypes.bool,
    includes_message: PropTypes.bool,
    guest_firstname: PropTypes.string,
    message_from_guest: PropTypes.string,
    message_sent_date: PropTypes.string,
  },

  getInitialState() {
    return {
      accepting: false,
      acceptCompleted: this.props.accepted,
      acceptFailed: false,
      acceptError: Immutable.Map({}),
      replying: false,
      replyCompleted: false,
      replyFailed: false,
      replyError: Immutable.Map({}),
      errors: Immutable.Map({}),
      fields: Immutable.Map({ reason: null }),
    };
  },

  getStoreInterests() {
    return {
      accepting: 'booking.accepting',
      acceptCompleted: 'booking.acceptCompleted',
      acceptFailed: 'booking.acceptFailed',
      acceptError: 'booking.acceptError',
      replying: 'conversation.creating',
      replyCompleted: 'conversation.createCompleted',
      replyFailed: 'conversation.createFailed',
      replyError: 'conversation.createError',
    };
  },

  componentDidMount() {
    if (!this.props.accepted) {
      BookingActionCreator.accept({
        id: this.props.booking_id,
      });
    }
  },

  componentDidUpdate(prevProps, prevState) {
    const acceptFailed = this.state.acceptFailed && !prevState.acceptFailed;
    const replyFailed = this.state.replyFailed && !prevState.replyFailed;

    if (acceptFailed || replyFailed) {
      ModalActionCreator.show({
        content: this._errorComponent(
          this._errorMessage(acceptFailed, replyFailed)
        ),
        className: 'small GlobalError-Modal-Plugin modal',
        settings: { closable: false },
        showButton: false,
        showIcon: false,
      });
    }
  },

  formSubmitted(params) {
    ConversationActionCreator.create_from_booking({
      booking_id: this.props.booking_id,
      message: this._guideMessage(),
    });
  },

  validationConstraints() {
    return {
      message: {
        presence: true,
      },
    };
  },

  _guideMessage() {
    return `${this.state.fields
      .get('message')
      .trim()}\n\nIn response to:\n\n${this.props.message_from_guest.trim()}`;
  },

  _errorMessage(acceptFailed, replyFailed) {
    let errorMessage;

    if (acceptFailed) {
      errorMessage =
        'Something went wrong while trying to accept your booking.';
    } else if (replyFailed) {
      errorMessage = 'Something went wrong while trying to send your message.';
    } else {
      errorMessage = 'Something went wrong.';
    }

    return errorMessage;
  },

  _errorComponent(errorMessage) {
    return (
      <GlobalError
        defaultErrorMessage={errorMessage}
        secondaryMessage="Please contact us at support@anyroad.com."
        showButton={false}
      />
    );
  },

  _messageProps() {
    return _.extend(this._formProps('message'), {
      placeholder: 'Enter your message here...',
    });
  },

  _renderMessageFromGuest() {
    return (
      <div className="AcceptBooking-message-from-guest">
        <div className="AcceptBooking-label">
          Message from {this.props.guest_firstname}
        </div>
        <div className="AcceptBooking-message-content">
          <div className="AcceptBooking-message-guest-name">
            {this.props.guest_firstname}
          </div>
          <div className="AcceptBooking-message-date">
            {this.props.message_sent_date}
          </div>
          <hr className="AcceptBooking-message-hr" />
          {this.props.message_from_guest}
        </div>
      </div>
    );
  },

  _renderGuideReply() {
    return (
      <div className="AcceptBooking-reply">
        <div className="AcceptBooking-label">Reply</div>
        <div className="AcceptBooking-reply-textarea">
          <TextArea {...this._messageProps()} />
        </div>
        <a className="AcceptBooking-button" onClick={this.onSubmit}>
          Send
        </a>
      </div>
    );
  },

  _renderReplySuccess() {
    return (
      <div className="AcceptBooking-success">
        <div className="AcceptBooking-checkmark">
          <i className="icon af-checkmark" />
          <span className="AcceptBooking-checkmark-text">Message sent!</span>
        </div>
      </div>
    );
  },

  _renderSuccessState() {
    return (
      <div
        className="AcceptBooking-success"
        data-testid="accept-booking-success-status"
      >
        <div className="AcceptBooking-checkmark">
          <i className="icon af-checkmark" />
          <span className="AcceptBooking-checkmark-text">Accepted!</span>
        </div>
        <div className="AcceptBooking-booking-details">
          The <span className="AcceptBooking-bold">{this.props.tour_name}</span>{' '}
          is confirmed for{' '}
          <span className="AcceptBooking-bold">{this.props.date}.</span>
        </div>
        <div className="AcceptedBooking-confirmation-copy">
          We’ve added the experience to your Bookings calendar, and sent you an
          email with more details and next steps.
        </div>
        {this.props.includes_message && !this.state.replyCompleted
          ? this._renderMessageFromGuest()
          : null}
        {this.props.includes_message && !this.state.replyCompleted
          ? this._renderGuideReply()
          : null}
        {this.state.replyCompleted ? this._renderReplySuccess() : null}
      </div>
    );
  },

  render() {
    return (
      <div className="AcceptBooking-wrapper">
        <Dimmer loader active={this.state.accepting || this.state.replying} />
        {this.state.acceptCompleted ? this._renderSuccessState() : null}
      </div>
    );
  },
});

export default AcceptBooking;
